export default __webpack_public_path__ + "static/media/NEWIMAGE.b7e22cd1.jpeg";